import { Instagram } from 'lucide-react';
import heroImage from '../../assets/hero-football.jpeg';
import playerLogo from '../../assets/player-logo.png';
import iosQrCode from '../../assets/ios_qr_black.png';
import androidQrCode from '../../assets/android_qr_black.png';
import appStoreBadge from '../../assets/appstoreSmall_.png';
import googlePlayBadge from '../../assets/googleplaySmall_.png';

const TikTokIcon = () => (
    <svg viewBox='0 0 24 24' fill='currentColor' className='w-5 h-5'>
        <path d='M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1-2.89-2.89 2.89 2.89 0 0 1 2.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 0 0-.79-.05 6.34 6.34 0 0 0-6.34 6.34 6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.75a8.18 8.18 0 0 0 4.76 1.52V6.84a4.83 4.83 0 0 1-1-.15z' />
    </svg>
);

const YouTubeIcon = () => (
    <svg viewBox='0 0 24 24' fill='currentColor' className='w-5 h-5'>
        <path d='M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z' />
    </svg>
);

const DesktopLandingPage = () => (
    <div
        className='fixed inset-0 overflow-hidden'
        style={{ backgroundColor: '#1a1a1c', zIndex: 9999 }}
    >
        {/* Header */}
        <header className='absolute top-0 left-0 right-0 z-10 flex items-center px-8 py-5'>
            <img src={playerLogo} alt='PLAYER' className='h-6' />
        </header>

        {/* Full-bleed background image + overlays */}
        <div className='absolute inset-0'>
            <img
                src={heroImage}
                alt='PLAYER athletes training on the pitch'
                className='absolute inset-0 w-full h-full object-cover'
                style={{ objectPosition: '75% 35%' }}
            />
            {/* Light global overlay */}
            <div
                className='absolute inset-0'
                style={{ backgroundColor: 'rgba(26,26,28,0.25)' }}
            />
            {/* Smooth left-to-right gradient */}
            <div
                className='absolute inset-0'
                style={{
                    background:
                        'linear-gradient(to right, #1a1a1c 0%, rgba(26,26,28,0.97) 25%, rgba(26,26,28,0.8) 40%, rgba(26,26,28,0.4) 55%, rgba(26,26,28,0.1) 70%, transparent 85%)'
                }}
            />
            {/* Vertical vignette */}
            <div
                className='absolute inset-0'
                style={{
                    background:
                        'linear-gradient(to top, rgba(26,26,28,0.5) 0%, transparent 40%, rgba(26,26,28,0.2) 100%)'
                }}
            />
        </div>

        {/* Content layer */}
        <div className='relative z-10 h-full flex'>
            {/* Left Content */}
            <div
                className='flex flex-col justify-center'
                style={{
                    maxWidth: '55%',
                    flex: 1,
                    paddingLeft: '4rem',
                    paddingRight: '2rem'
                }}
            >
                <h1
                    className='font-black uppercase text-white mb-5'
                    style={{
                        fontSize: 'clamp(2.5rem, 4vw, 4.5rem)',
                        lineHeight: 0.9,
                        letterSpacing: '-0.03em'
                    }}
                >
                    ACCESS THE
                    <br />
                    <span style={{ color: '#52FF00' }}>PLAYER</span> NETWORK.
                </h1>

                <p
                    className='leading-relaxed mb-10'
                    style={{
                        color: 'rgba(200,210,230,0.8)',
                        fontSize: '0.875rem',
                        maxWidth: '32rem'
                    }}
                >
                    PLAYER is mobile-only and invite-only. Join the waitlist to
                    get access, or download the app if you&apos;ve already got
                    an account.{' '}
                    <a
                        href='https://join.playerapp.co/'
                        target='_blank'
                        rel='noopener noreferrer'
                        style={{
                            color: 'rgba(248,250,252,0.85)',
                            textDecoration: 'none',
                            fontSize: 'inherit'
                        }}
                    >
                        Learn more →
                    </a>
                </p>

                <div style={{ maxWidth: '32rem' }}>
                    <h2
                        className='font-bold uppercase text-white mb-1'
                        style={{
                            fontSize: '1.125rem',
                            letterSpacing: '0.05em'
                        }}
                    >
                        Join the waitlist
                    </h2>
                    <p
                        className='mb-5'
                        style={{ fontSize: '0.75rem', color: '#9ca3af' }}
                    >
                        Access is via the waitlist.
                    </p>
                    <a
                        href='https://join.playerapp.co/'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='font-bold uppercase text-black rounded-full'
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            backgroundColor: '#52FF00',
                            width: '360px',
                            maxWidth: '100%',
                            height: '3.5rem',
                            fontSize: '0.875rem',
                            boxShadow: '0 0 20px rgba(82,255,0,0.15)',
                            letterSpacing: '0.05em',
                            textDecoration: 'none'
                        }}
                    >
                        JOIN NOW
                    </a>
                </div>
            </div>

            {/* Right — QR overlay area */}
            <div className='relative' style={{ flex: 1, minWidth: '45%' }}>
                {/* QR Overlay — Bottom Right */}
                <div
                    className='absolute rounded-2xl'
                    style={{
                        bottom: '90px',
                        right: '2.5rem',
                        zIndex: 10,
                        backgroundColor: 'rgba(26,26,28,0.6)',
                        backdropFilter: 'blur(12px)',
                        border: '1px solid rgba(255,255,255,0.15)',
                        padding: '1.75rem'
                    }}
                >
                    <p
                        className='font-bold uppercase text-white mb-1'
                        style={{
                            fontSize: '0.875rem',
                            letterSpacing: '0.05em'
                        }}
                    >
                        Already have an account?
                    </p>
                    <p
                        className='mb-5'
                        style={{ fontSize: '0.75rem', color: '#9ca3af' }}
                    >
                        Download the app
                    </p>
                    <div className='flex' style={{ gap: '2rem' }}>
                        <div
                            className='flex flex-col items-center'
                            style={{ gap: '0.75rem' }}
                        >
                            <img
                                src={iosQrCode}
                                alt='Scan to download on the App Store'
                                style={{ width: '120px', height: '120px' }}
                            />
                            <img
                                src={appStoreBadge}
                                alt='Download on the App Store'
                                style={{ width: '130px', height: 'auto' }}
                            />
                        </div>
                        <div
                            className='flex flex-col items-center'
                            style={{ gap: '0.75rem' }}
                        >
                            <img
                                src={androidQrCode}
                                alt='Scan to get it on Google Play'
                                style={{ width: '120px', height: '120px' }}
                            />
                            <img
                                src={googlePlayBadge}
                                alt='Get it on Google Play'
                                style={{ width: '130px', height: 'auto' }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        {/* Footer */}
        <footer className='absolute bottom-0 left-0 right-0 z-30 flex items-center justify-between px-8 py-5'>
            <div className='flex items-center' style={{ gap: '1.75rem' }}>
                <a
                    href='https://www.instagram.com/playerfcofficial'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: 'rgba(82,255,0,0.75)' }}
                >
                    <Instagram size={18} />
                </a>
                <a
                    href='https://www.tiktok.com/@playerfcofficial'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: 'rgba(82,255,0,0.75)' }}
                >
                    <TikTokIcon />
                </a>
                <a
                    href='https://www.youtube.com/@playerfcofficial'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ color: 'rgba(82,255,0,0.75)' }}
                >
                    <YouTubeIcon />
                </a>
            </div>
            <div className='flex items-center' style={{ gap: '1.5rem' }}>
                <a
                    href='https://join.playerapp.co/tcs'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        fontSize: '0.75rem',
                        color: '#9ca3af',
                        textDecoration: 'none'
                    }}
                >
                    Terms &amp; Conditions
                </a>
                <a
                    href='https://join.playerapp.co/privacypolicy'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        fontSize: '0.75rem',
                        color: '#9ca3af',
                        textDecoration: 'none'
                    }}
                >
                    Privacy Policy
                </a>
            </div>
        </footer>
    </div>
);

export default DesktopLandingPage;
